const ViewMap=(props)=>{
    const handleRouteClick = (params) => {
        props.onClickShowRoute(props);
    };
    return (
        <a onClick={handleRouteClick} title="View Route"><i className="icofont icofont-map-pins f20"></i> </a>
    );
}
export default ViewMap